<template>
  <svg
    width="104"
    height="86"
    viewBox="0 0 104 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.9936 0H17.2007C7.70103 0 0 7.70103 0 17.2007V68.7928C0 78.2925 7.70103 85.9936 17.2007 85.9936H85.9936C95.4933 85.9936 103.194 78.2925 103.194 68.7928V17.2007C103.194 7.70103 95.4933 0 85.9936 0Z"
      fill="#0B132B"
    />
    <g style="mix-blend-mode:hard-light">
      <path
        d="M103.194 17.1906L93.2424 19.671C66.4744 26.1706 39.3217 32.6804 13.0094 38.9877C8.66617 40.0304 4.32296 41.0732 0 42.1059V17.1906C0 7.68414 7.70439 0 17.2109 0H86.0037C95.5101 0 103.194 7.69427 103.194 17.1906Z"
        fill="url(#paint0_linear_9_982)"
      />
    </g>
    <path
      d="M85.9936 2.42977C94.1434 2.42977 100.765 9.06101 100.765 17.2007V68.8029C100.765 76.9528 94.1333 83.5739 85.9936 83.5739H17.2007C9.05088 83.5739 2.42976 76.9427 2.42976 68.8029V17.2007C2.42976 9.05089 9.06101 2.42977 17.2007 2.42977H85.9936ZM85.9936 0H17.2007C7.70439 0 0 7.70439 0 17.2007V68.8029C0 78.2993 7.70439 86.0037 17.2007 86.0037H85.9936C95.4899 86.0037 103.194 78.2993 103.194 68.8029V17.2007C103.194 7.70439 95.5 0 85.9936 0Z"
      fill="#0B132B"
    />
    <path
      d="M69.4246 21.0103C68.807 21.0103 68.1793 21.2431 67.7136 21.719C66.762 22.6706 66.762 24.1993 67.7136 25.151C71.4696 28.907 76.4507 31.0331 81.7557 31.1444C83.0718 31.2052 84.2057 30.1118 84.236 28.7653C84.2664 27.4289 83.2034 26.3153 81.8569 26.2849C77.8073 26.1938 74.0006 24.5739 71.1457 21.7088C70.6698 21.233 70.0523 21.0002 69.4246 21.0002V21.0103Z"
      fill="#4CE0B3"
    />
    <path
      d="M33.8121 21.0102C34.4297 21.0102 35.0574 21.243 35.5231 21.7188C36.4747 22.6705 36.4747 24.1992 35.5231 25.1509C31.7671 28.9069 26.786 31.0329 21.481 31.1443C20.1649 31.2051 19.031 30.1117 19.0006 28.7652C18.9703 27.4288 20.0333 26.3152 21.3798 26.2848C25.4294 26.1937 29.236 24.5738 32.091 21.7087C32.5669 21.2329 33.1844 21 33.8121 21V21.0102Z"
      fill="#4CE0B3"
    />
    <g filter="url(#filter0_f_9_982)">
      <path
        d="M74 41L62 48L74 55"
        stroke="#4CE0B3"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <path
      d="M74 41L62 48L74 55"
      stroke="#4CE0B3"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M74 41L62 48L74 55"
      stroke="#A6F4D8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <g filter="url(#filter1_f_9_982)">
      <path
        d="M30 41L42 48L30 55"
        stroke="#4CE0B3"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <path
      d="M30 41L42 48L30 55"
      stroke="#4CE0B3"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30 41L42 48L30 55"
      stroke="#A6F4D8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_f_9_982"
        x="55.5"
        y="34.4996"
        width="25.0004"
        height="27.0007"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_9_982"
        />
      </filter>
      <filter
        id="filter1_f_9_982"
        x="23.4996"
        y="34.4996"
        width="25.0004"
        height="27.0007"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_9_982"
        />
      </filter>
      <linearGradient
        id="paint0_linear_9_982"
        x1="125.012"
        y1="-14.9633"
        x2="18.5675"
        y2="22.8601"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2853E1" />
        <stop
          offset="1"
          stop-color="#2853E1"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
